function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 4,
  fill: "#6AED8E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0938 10.775C16.8838 9.71107 16.311 8.75304 15.4732 8.06453C14.6353 7.37602 13.5844 6.99975 12.5 7C10.6937 7 9.125 8.025 8.34375 9.525C7.42515 9.62427 6.57563 10.0595 5.95843 10.7471C5.34123 11.4346 4.99989 12.326 5 13.25C5 15.3188 6.68125 17 8.75 17H16.875C18.6 17 20 15.6 20 13.875C20 12.225 18.7188 10.8875 17.0938 10.775ZM16.875 15.75H8.75C7.36875 15.75 6.25 14.6312 6.25 13.25C6.25 11.9688 7.20625 10.9 8.475 10.7687L9.14375 10.7L9.45625 10.1063C9.74367 9.54674 10.1799 9.07738 10.717 8.74987C11.254 8.42236 11.871 8.24939 12.5 8.25C14.1375 8.25 15.55 9.4125 15.8687 11.0188L16.0563 11.9563L17.0125 12.025C17.4823 12.0566 17.9228 12.265 18.2451 12.6082C18.5675 12.9515 18.7479 13.4041 18.75 13.875C18.75 14.9062 17.9062 15.75 16.875 15.75ZM11.25 13.3625L9.94375 12.0563L9.0625 12.9375L11.25 15.125L15.0063 11.3687L14.125 10.4875L11.25 13.3625Z",
  fill: "white"
});

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.63051170.svg";
export { ForwardRef as ReactComponent };